import styled, { css } from "styled-components";

type FloatingButtonContainerProps = {
  $position: "BOTTOM_RIGHT" | "BOTTOM_LEFT";
  $isEditor?: boolean;
};

type FloatingButtonProps = {
  $buttonColor: string;
};

export const FloatingButtonContainer = styled.div<FloatingButtonContainerProps>`
  position: fixed;
  bottom: 110px;
  ${({ $position }) =>
    $position === "BOTTOM_RIGHT"
      ? css`
          right: 24px;
        `
      : css`
          left: 24px;
        `}
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: ${({ $position }) =>
    $position === "BOTTOM_RIGHT" ? "flex-end" : "flex-start"};
  gap: 16px;

  ${({ $position, $isEditor }) =>
    $isEditor
      ? css`
          position: sticky;
          bottom: 110px;
          
          ${$position === "BOTTOM_RIGHT"
          ? css`
                margin-left: auto;
                margin-right: 24px; 
              `
          : css`
                margin-right: auto;
                margin-left: 24px;
              `}
        `
      : css`
          position: fixed;
          bottom: 110px;
          
          ${$position === "BOTTOM_RIGHT"
          ? css`
                right: 24px;
              `
          : css`
                left: 24px;
              `}
        `}



  @media (max-width: 768px) {
    bottom: 110px;
    ${({ $position }) =>
    $position === "BOTTOM_RIGHT"
      ? css`
            right: 16px;
          `
      : css`
            left: 16px;
          `}
  }
`;

export const FloatingButton = styled.button<FloatingButtonProps>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${({ $buttonColor }) => $buttonColor};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2), 0 3px 6px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(1.05);
  }

  &:focus-visible {
    outline: 3px solid ${({ $buttonColor }) => $buttonColor};
    outline-offset: 2px;
  }

  svg {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const DropdownWrapper = styled.div`
  width: 303px;
  max-width: calc(100vw - 32px);
  --dropdown-max-height: calc(100dvh - 220px);
  animation: slideUp 0.25s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

type IconWrapperProps = {
  $isOpen: boolean;
};

export const IconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease, opacity 0.2s ease;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(90deg);
    `}
`;
